import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import { isEmpty, map, size } from "lodash";
import { withTranslation } from "react-i18next"
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import {postHomePref, getHomePref, updateHomePref, getClientDetail, createAddHomePref, getAddHomePref, updateAddHomePref } from "../../store/actions"
import DeleteModal from "../../components/Common/DeleteModal";
import editIcon from "../../assets/images/icons/edit2.png";
import deleteIcon from "../../assets/images/icons/bin.png";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
  CardImg,
  Nav,
  NavItem,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader
} from "reactstrap"
import { Link } from "react-router-dom/cjs/react-router-dom.min";


class homePref extends Component {
    constructor(props) {
        super(props)
        this.state = {
          homeprefrence:'',
          addprefrence:''
        }

        this.handleHomePrefSubmit = this.handleHomePrefSubmit.bind(this);
        this.toggleRightCanvas = this.toggleRightCanvas.bind(this);
        this.toggleBackdrop = this.toggleBackdrop.bind(this);
        this.onClickDelete = this.onClickDelete.bind(this);
        this.toggleAddNew = this.toggleAddNew.bind(this);
        this.submitAddHomePrefData  = this.submitAddHomePrefData.bind(this);
        this.toggleUpdateAddPref  = this.toggleUpdateAddPref.bind(this);
    }
    handleGoBack = (e) => {
      e.preventDefault();
      console.log("Go Back Triggered");
      const { history } = this.props;
      if (history.length !== "POP" ) {
        history.goBack();
      } else {
        history.push("/project"); 
      }
    };
    toggleAddNew() {
      this.setState({ isAddNew: !this.state.isAddNew });
  
    }
    toggleBackdrop() {
      this.setState({ isBackdrop: !this.state.isBackdrop });
    }
    toggleDeleteModal = () => {
      this.setState(prevState => ({
        deleteModal: !prevState.deleteModal,
      }));
    };
    onClickDelete = (homeprefrence) => {
      this.setState({ homeprefrence: homeprefrence });
      this.setState({ deleteModal: true });
    };
  
    handleDeleteHomePref = () => {
      const { onDeleteHomePref } = this.props;
      const { homeprefrence } = this.state;
    
      if (homeprefrence.id !== undefined) {
        onDeleteHomePref(homeprefrence);
        this.setState({ deleteModal: false });
      }
    };
    toggle() {
      this.setState(prevState => ({
        isRight: !prevState.isRight
      }));
    }
    updateToggle() {
      this.setState(prevState => ({
        isUpdate: !prevState.isUpdate
      }));
    }
    handleHomePrefSubmit(value){
      const payload = {
        id:value.id,
        clientStandardHomePreferenceId:value.clientStandardHomePreferenceId,
        typeOfHouse:value.typeOfHouse,
        minPrice:parseInt(value.minPrice),
        maxPrice:parseInt(value.maxPrice),
        sqFeets:value.sqFeets,
        bedRoom:value.bedRoom,
        bathRoom:value.bathRoom,
        clientId:parseInt(value.clientId),
        clientGuid:value.clientGuid,
        city:value.city,
        preferenceDescription:value.preferenceDescription
      }
      if (value.id > 0) {
        this.props.updateHomePref(payload, this.props.history);
      } else {
      
        this.props.postHomePref(payload, this.props.history);
      }
      
  
    }
    submitAddHomePrefData(value){
      const payload = {
        clientId:parseInt(value.clientId),
        agentId:parseInt(localStorage.getItem('agentId')),
        clientGuid:value.clientGuid,
        clientAdditionalHomePreferenceTitle:value.clientAdditionalHomePreferenceTitle,
        clientAdditionalHomePreferenceDescription:value.clientAdditionalHomePreferenceDescription,
        clientAdditionalHomePreferenceIsActive:value.clientAdditionalHomePreferenceIsActive
      }
     
      this.props.createAddHomePref(payload, this.props.history);
  
    }
    componentDidMount() {
      const { onGetHomePref, onGetClientDetail, onGetAddHomePref } = this.props;
      onGetClientDetail(localStorage.getItem('userId'));
      if (this.props.clientDetail?.clientId) {
        onGetHomePref(this.props.clientDetail.clientId);
        //console.log(this.props.clientDetail.clientId);
        onGetAddHomePref(this.props.clientDetail.clientId);
      }
  }
  componentDidUpdate(prevProps) {
    const { homeprefrences, addprefrences, clientDetail, onGetHomePref, onGetAddHomePref } = this.props;   
    if (prevProps.clientDetail?.clientId !== clientDetail?.clientId) {
      onGetHomePref(clientDetail.clientId);
      onGetAddHomePref(clientDetail.clientId);
    }
    if (!isEmpty(homeprefrences) && size(prevProps.homeprefrences) !== size(homeprefrences)) {
      this.setState({ homeprefrences: {}, isEdit: false }); 
    }
    if (!isEmpty(addprefrences) && size(prevProps.addprefrences) !== size(addprefrences)) {
      this.setState({ addprefrence: {}, isUpdateEdit: false }); 
    }
  }
  toggleRightCanvas() {
    this.setState({ homeprefrence: "", isEdit: false, isRight: !this.state.isRight });
    this.toggle();
  }
  toggleRightCanvas = arg => {
    const homeprefrence = arg;
    this.setState({
      homeprefrence: {
        id: homeprefrence.id,
        clientStandardHomePreferenceId: homeprefrence.clientStandardHomePreferenceId,
        clientId: homeprefrence.clientId,
        clientGuid:homeprefrence.clientGuid,
        typeOfHouse:homeprefrence.typeOfHouse,
        minPrice:homeprefrence.minPrice,
        maxPrice:homeprefrence.maxPrice,
        sqFeets: homeprefrence.sqFeets,
        bedRoom:homeprefrence.bedRoom,
        bathRoom:homeprefrence.bathRoom,
        city:homeprefrence.city,
        preferenceDescription:homeprefrence.preferenceDescription
      },
      isEdit: true,
    });
    this.toggle();
  };


  toggleUpdateAddPref () {
    this.setState({ addprefrence: "", isUpdateEdit: false, isUpdate: !this.state.isUpdate });
    this.updateToggle();
  }
  toggleUpdateAddPref  = arg => {
    const addprefrence = arg;
    this.setState({
      addprefrence: {
        id: addprefrence.id,
        clientAdditionalHomePreferenceId: addprefrence.clientAdditionalHomePreferenceId,
        clientId: addprefrence.clientId,
        clientGuid:addprefrence.clientGuid,
        clientAdditionalHomePreferenceTitle:addprefrence.clientAdditionalHomePreferenceTitle,
        clientAdditionalHomePreferenceDescription:addprefrence.clientAdditionalHomePreferenceDescription,
        clientAdditionalHomePreferenceDisplay:addprefrence.clientAdditionalHomePreferenceDisplay,
        clientAdditionalHomePreferenceIsActive: addprefrence.clientAdditionalHomePreferenceIsActive,
        isStandardFeature:addprefrence.isStandardFeature,
      },
      isUpdateEdit: true,
    });
    this.updateToggle();
  };
    render() {
        const {homeprefrences, clientDetail, onUpdateHomePref, addprefrences, onUpdateAddPref } = this.props;
        const { isEdit, deleteModal, homeprefrence, addprefrence, isUpdateEdit } = this.state;
      
        return (
            <React.Fragment>
              {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null} 
              <ToastContainer autoClose={2000} />
              <DeleteModal
              show={deleteModal}
              onDeleteClick={this.handleDeleteHomePref}
              onCloseClick={() => this.setState({ deleteModal: false })}
            />
                <div className="page-content">
          <MetaTags>
            <title>Preferences | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Buyer")}
              breadcrumbItem={this.props.t("Home Preferences")}
            /> */}
              <Row>
                  <Col sm="12">
              
                  <Row>
                  <Col sm="3">
                 
               
                  </Col>
      <Col lg="9">
        <Nav tabs className="projectTab pref-tab">
     
        <NavItem>
              <Link 
                className={`nav-link`} 
                to="#"
                onClick={this.handleGoBack}
              >
                <span className="d-none d-sm-block">Back</span>
              </Link>
              </NavItem>
            <NavItem>
              <Link 
                className={`nav-link active`} 
                to="/prefrences/home-prefrences"
              >
                <span className="d-none d-sm-block">My Home</span>
              </Link>
              </NavItem>
              <NavItem>
              <Link 
                className={`nav-link`} 
                to="/prefrences/important-destinations"
              >
                <span className="d-none d-sm-block">Important Destinations</span>
              </Link>
            </NavItem>
        
        </Nav>
      </Col>
                    <Col sm="12">
                      <Card className="rs-card-bg"> 
                        <CardBody className="text-rs">
                          <h5 className="card-title text-uppercase client-main-card-title">define your home preferences <small>( Your agent can see this list to help match you with the right properties.)</small></h5>
                          <p style={{fontSize:16}}>
                          Create your ideal home profile by selecting standard features and adding personalized preferences.
                          Specify your must-haves, including:
                          </p>
                          <ul>
                            <li>Home type and size</li>
                            <li>Number of bedrooms and bathrooms</li>
                          </ul>

                          <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id:homeprefrences?.id || 0,
                    clientStandardHomePreferenceId: homeprefrences?.clientStandardHomePreferenceId || '0580dbc4-463f-4570-99b9-7fbccd84756d',
                    typeOfHouse:homeprefrences?.typeOfHouse,
                    minPrice: homeprefrences?.minPrice  || "",
                    maxPrice: homeprefrences?.minPrice  || "",
                    sqFeets:  homeprefrences?.sqFeets   || "",
                    bedRoom: homeprefrences?.bedRoom    || "",
                    bathRoom: homeprefrences?.bathRoom  || "",
                    city:     homeprefrences?.city  || "",
                    preferenceDescription:  homeprefrences?.preferenceDescription  || "",
                    clientId: localStorage.getItem('userId'),
                    clientGuid:clientDetail?.clientId
                    

                  }}
                  validationSchema={Yup.object().shape({
                    typeOfHouse: Yup.string().required("This is Required"),
                    minPrice: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  maxPrice: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  sqFeets: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  bedRoom: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  bathRoom: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                })}

                  onSubmit={this.handleHomePrefSubmit}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
              
                   <Row>
                   <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="typeOfHouse">
                              {this.props.t("Type of house")}
                            </Label>
                            <Field as="select" name="typeOfHouse" 
                            className={
                              "form-control" +
                              (errors.typeOfHouse && touched.typeOfHouse
                                ? " is-invalid"
                                : "")
                            }
                            onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="Condo">Condo</option>
                               
                            </Field>
                            <ErrorMessage
                                  name="typeOfHouse"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>  
                        <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="city">
                              {this.props.t("City")}
                            </Label>
                            <Field
                              name="city"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.city && touched.city
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>
                        <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="minPrice">
                              {this.props.t("Min. price")}
                            </Label>
                            <Field
                              name="minPrice"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.minPrice && touched.minPrice
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="minPrice"
                            />
                                <ErrorMessage
                                  name="minPrice"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>

                        <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="maxPrice">
                              {this.props.t("Max price")}
                            </Label>
                            <Field
                              name="maxPrice"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.maxPrice && touched.maxPrice
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="maxPrice"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>

                        <Col sm="2">
                        <FormGroup className="mb-3">
                            <Label htmlFor="sqFeets">
                              {this.props.t("Square feet")}
                            </Label>
                            <Field
                              name="sqFeets"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.sqFeets && touched.sqFeets
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="sqFeets"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>
                        <Col sm="1">
                        <FormGroup className="mb-3">
                            <Label htmlFor="bedRoom">
                              {this.props.t("# BR")}
                            </Label>
                            <Field
                              name="bedRoom"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.bedRoom && touched.bedRoom
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="bedRoom"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col> 
                        <Col sm="1">
                        <FormGroup className="mb-3">
                            <Label htmlFor="bathRoom">
                              {this.props.t("# of Bath")}
                            </Label>
                            <Field
                              name="bathRoom"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.bathRoom && touched.bathRoom
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="bathRoom"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col> 
                       <Col sm="2">  <div className="clearfix"><button style={{ marginTop: 10}} type="submit" className="btn btn-primary w-sm">Save</button></div></Col>
                    </Row>
              
                
                </Form>
                  )}
                          </Formik>

                   </CardBody>
                   </Card>


                   <Card className="rs-card-bg"> 
                   <CardBody className="text-rs">

                   <h5 className="card-title text-uppercase  client-main-card-title">Create your custom preferences <small>(Your agent can see this list to help match you with the right properties.)</small></h5>

                        <ul>
                            <li>Desired amenities (pool, gym, etc.)</li>
                            <li>Proximity to public transport, schools, shopping, entertainment, and more</li>
                          </ul>

                          <button style={{ marginTop: 20}} type="button" className="btn btn-custom w-sm" onClick={this.toggleAddNew}>Add New</button>


                          <div className="">
                   <table className="table table-striped">
                      
                      <tbody>
                      {addprefrences && addprefrences.length > 0 ? (
                          addprefrences.map((preference, index) => (
                                <tr key={index}>
                                    <td>{preference.clientAdditionalHomePreferenceDisplay}</td>
                                  
                                    <td>
                                            <div className="d-flex gap-3">
                                              <img className='tab-img me-2' style={{cursor:'pointer'}} src={editIcon} onClick={() => this.toggleUpdateAddPref(preference)} /> <img className='tab-img' style={{cursor:'pointer'}} src={deleteIcon} onClick={() => this.onClickDelete(preference)} />
                                            
                                            </div>
                                            </td>
                                </tr>
                                 ))
                                ) : (
                                  <tr>
                                    <td  style={{ textAlign: "center" }}>No preferences found</td>
                                  </tr>
                                  )}
                                </tbody>
                    </table>


                  </div>
                        </CardBody>
                      </Card>
                    </Col>
                </Row>
                  </Col>
                   
              </Row>
              
   
            </Container>
            </div>

            <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleRightCanvas}
            >
              <OffcanvasHeader toggle={this.toggleRightCanvas}>
                Update
              </OffcanvasHeader>
              <OffcanvasBody>
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: homeprefrence.id,
                    clientStandardHomePreferenceId: homeprefrence.clientStandardHomePreferenceId,
                    clientId: homeprefrence.clientId,
                    clientGuid:homeprefrence.clientGuid,
                    typeOfHouse:homeprefrence.typeOfHouse,
                    minPrice:homeprefrence.minPrice,
                    maxPrice:homeprefrence.maxPrice,
                    sqFeets: homeprefrence.sqFeets,
                    bedRoom:homeprefrence.bedRoom,
                    bathRoom:homeprefrence.bathRoom,
                    city:homeprefrence.city,
                    preferenceDescription:homeprefrence.preferenceDescription
                    

                  }}
                  validationSchema={Yup.object().shape({
                    typeOfHouse: Yup.string().required("This is Required"),
                    minPrice: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  maxPrice: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  sqFeets: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  bedRoom: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                  bathRoom: Yup.number()
                    .transform((value, originalValue) => (originalValue === "" ? null : value))
                    .typeError("Must be a number")
                    .integer("Must be an integer")
                    .required("This field is required"),
                })}

                onSubmit={values => {

                  if (isEdit) {
                    const updateData = {
                      id: values.id,
                      clientStandardHomePreferenceId: values.clientStandardHomePreferenceId,
                      clientId: parseInt(values.clientId),
                      clientGuid:values.clientGuid,
                      typeOfHouse:values.typeOfHouse,
                      minPrice:parseInt(values.minPrice),
                      maxPrice:parseInt(values.maxPrice),
                      sqFeets: parseInt(values.sqFeets),
                      bedRoom:parseInt(values.bedRoom),
                      bathRoom:parseInt(values.bathRoom),
                      city:values.city,
                      preferenceDescription:values.preferenceDescription
                    };
                    onUpdateHomePref(updateData);
                  } else {

                  }
                  this.toggle();
                }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
              
                   <Row>
                   <Col sm="12">
                        <FormGroup className="mb-3">
                            <Label htmlFor="typeOfHouse">
                              {this.props.t("Type of house")}
                            </Label>
                            <Field as="select" name="typeOfHouse" 
                            className={
                              "form-control" +
                              (errors.typeOfHouse && touched.typeOfHouse
                                ? " is-invalid"
                                : "")
                            }
                            onChange={handleChange}>
                                <option value="">Select</option>
                                <option value="Condo">Condo</option>
                               
                            </Field>
                            <ErrorMessage
                                  name="typeOfHouse"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>  
                        <Col sm="6">
                        <FormGroup className="mb-3">
                            <Label htmlFor="minPrice">
                              {this.props.t("Min. price")}
                            </Label>
                            <Field
                              name="minPrice"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.minPrice && touched.minPrice
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="minPrice"
                            />
                                <ErrorMessage
                                  name="minPrice"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                        <FormGroup className="mb-3">
                            <Label htmlFor="maxPrice">
                              {this.props.t("Max price")}
                            </Label>
                            <Field
                              name="maxPrice"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.maxPrice && touched.maxPrice
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="maxPrice"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>

                        <Col sm="6">
                        <FormGroup className="mb-3">
                            <Label htmlFor="sqFeets">
                              {this.props.t("Square feet")}
                            </Label>
                            <Field
                              name="sqFeets"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.sqFeets && touched.sqFeets
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="sqFeets"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col>
                        <Col sm="6">
                        <FormGroup className="mb-3">
                            <Label htmlFor="bedRoom">
                              {this.props.t("# Bedrooms")}
                            </Label>
                            <Field
                              name="bedRoom"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.bedRoom && touched.bedRoom
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="bedRoom"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col> 
                        <Col sm="6">
                        <FormGroup className="mb-3">
                            <Label htmlFor="bathRoom">
                              {this.props.t("# of bathrooms")}
                            </Label>
                            <Field
                              name="bathRoom"
                              onChange={handleChange}                            
                              type="text"
                              
                              className={
                                "form-control" +
                                (errors.bathRoom && touched.bathRoom
                                  ? " is-invalid"
                                  : "")
                              }
                             
                              id="mls"
                            />
                                <ErrorMessage
                                  name="bathRoom"
                                  component="div"
                                  className="invalid-feedback"
                                />
                          </FormGroup>
                        </Col> 
                       <Col sm="12">  <div className="clearfix"><button type="submit" className="btn btn-primary w-sm">Update</button></div></Col>
                    </Row>
              
                
                </Form>
                  )}
                          </Formik>
              </OffcanvasBody>
            </Offcanvas>


            <Offcanvas
              isOpen={this.state.isAddNew}
              direction="end"
              toggle={this.toggleAddNew}
              style={{ width: 800 }}

            >
              <OffcanvasHeader toggle={this.toggleAddNew}>
                Add New
              </OffcanvasHeader>
              <OffcanvasBody>
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    clientId: localStorage.getItem('userId'),
                    clientGuid: clientDetail?.clientId,
                    clientAdditionalHomePreferenceTitle: "",
                    clientAdditionalHomePreferenceDescription: "Must Have",
                    clientAdditionalHomePreferenceIsActive: true
                
                    

                  }}
                  validationSchema={Yup.object().shape({
                    clientAdditionalHomePreferenceTitle: Yup.string().required("This is Required"),
                   
                })}

                onSubmit={this.submitAddHomePrefData}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
              
                   <Row>
                   <Col sm="6">
                   <FormGroup className="mb-3">
                                  <Label htmlFor="clientAdditionalHomePreferenceTitle">
                                    {this.props.t("Title *")}
                                  </Label>
                                  <Field
                                    name="clientAdditionalHomePreferenceTitle"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.clientAdditionalHomePreferenceTitle && touched.clientAdditionalHomePreferenceTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="clientAdditionalHomePreferenceTitle"
                                  />
                                  <ErrorMessage
                                    name="clientAdditionalHomePreferenceTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                        </Col>  
                        <Col sm="6">
                        <div className="btn-group" role="group" style={{marginTop:27}}>
                          <Field type="radio" className="btn-check" name="clientAdditionalHomePreferenceDescription" id="btnradio4" autoComplete="off" value="Must Have" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio4">Must Have</label>

                          <Field type="radio" className="btn-check" name="clientAdditionalHomePreferenceDescription" id="btnradio5" value="Nice to Have" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio5">Nice to Have</label>

                        
                        </div>
                        </Col>
                       <Col sm="12">  <div className="clearfix"><button type="submit" className="btn btn-primary w-sm">Add New</button></div></Col>
                    </Row>
              
                
                </Form>
                  )}
                          </Formik>
              </OffcanvasBody>
            </Offcanvas>


            <Offcanvas
              isOpen={this.state.isUpdate}
              direction="end"
              toggle={this.toggleUpdateAddPref }
              style={{ width: 800 }}

            >
              <OffcanvasHeader toggle={this.toggleUpdateAddPref }>
                Update
              </OffcanvasHeader>
              <OffcanvasBody>
              <Formik
                  enableReinitialize={true}
                  initialValues={{
                    id: addprefrence.id,
                    clientAdditionalHomePreferenceId: addprefrence.clientAdditionalHomePreferenceId,
                    clientId: addprefrence.clientId,
                    clientGuid:addprefrence.clientGuid,
                    clientAdditionalHomePreferenceTitle:addprefrence.clientAdditionalHomePreferenceTitle,
                    clientAdditionalHomePreferenceDescription:addprefrence.clientAdditionalHomePreferenceDescription,
                    clientAdditionalHomePreferenceDisplay:addprefrence.clientAdditionalHomePreferenceDisplay,
                    clientAdditionalHomePreferenceIsActive: addprefrence.clientAdditionalHomePreferenceIsActive,
                    isStandardFeature:addprefrence.isStandardFeature,
                
                    

                  }}
                  validationSchema={Yup.object().shape({
                    clientAdditionalHomePreferenceTitle: Yup.string().required("This is Required"),
                   
                })}

                onSubmit={values => {

                  if (isUpdateEdit) {
                    const updateData = {
                      id: values.id,
                      clientAdditionalHomePreferenceId: values.clientAdditionalHomePreferenceId,
                      clientId: values.clientId,
                      clientGuid:values.clientGuid,
                      clientAdditionalHomePreferenceTitle:values.clientAdditionalHomePreferenceTitle,
                      clientAdditionalHomePreferenceDescription:values.clientAdditionalHomePreferenceDescription,
                      clientAdditionalHomePreferenceDisplay:values.clientAdditionalHomePreferenceDisplay,
                      clientAdditionalHomePreferenceIsActive: values.clientAdditionalHomePreferenceIsActive,
                      isStandardFeature:values.isStandardFeature,
                    };
                    onUpdateAddPref(updateData);
                  } else {

                  }
                  this.updateToggle();
                }}
                >
                  {({ errors, touched, values, handleChange, setFieldValue }) => (
                    <Form
                      className="needs-validation"
                    >
             
              
                   <Row>
                   <Col sm="6">
                   <FormGroup className="mb-3">
                                  <Label htmlFor="clientAdditionalHomePreferenceTitle">
                                    {this.props.t("Title *")}
                                  </Label>
                                  <Field
                                    name="clientAdditionalHomePreferenceTitle"
                                    type="text"
                                    onChange={handleChange}
                                    className={
                                      "form-control" +
                                      (errors.clientAdditionalHomePreferenceTitle && touched.clientAdditionalHomePreferenceTitle
                                        ? " is-invalid"
                                        : "")
                                    }
                                    id="clientAdditionalHomePreferenceTitle"
                                  />
                                  <ErrorMessage
                                    name="clientAdditionalHomePreferenceTitle"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </FormGroup>
                        </Col>  
                        <Col sm="6">
                        <div className="btn-group" role="group" style={{marginTop:27}}>
                          <Field type="radio" className="btn-check" name="clientAdditionalHomePreferenceDescription" id="btnradio4" autoComplete="off" value="Must Have" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio4">Must Have</label>

                          <Field type="radio" className="btn-check" name="clientAdditionalHomePreferenceDescription" id="btnradio5" value="Nice to Have" autoComplete="off" />
                          <label className="btn btn-outline-secondary" htmlFor="btnradio5">Nice to Have</label>

                        
                        </div>
                        </Col>
                       <Col sm="12">  <div className="clearfix"><button type="submit" className="btn btn-primary w-sm">Add New</button></div></Col>
                    </Row>
              
                
                </Form>
                  )}
                          </Formik>
              </OffcanvasBody>
            </Offcanvas>
            </React.Fragment>
        )
    }
}
homePref.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    postHomePref:PropTypes.func,
    onGetHomePref:PropTypes.func,
    homeprefrences:PropTypes.object,
    loading:PropTypes.object,
    onDeleteHomePref:PropTypes.func,
    onUpdateHomePref:PropTypes.func,
    onGetClientDetail:PropTypes.func,
    clientDetail:PropTypes.object,
    createAddHomePref:PropTypes.func,
    onGetAddHomePref:PropTypes.func,
    addprefrences:PropTypes.array,
    onUpdateAddPref:PropTypes.func,
    updateHomePref:PropTypes.func
    

}

const mapStateToProps = ({ Prefrences, Profile }) => (
    {
      clientDetail: Profile.clientDetail,
      homeprefrences : Prefrences.homeprefrences,
      loading:Prefrences.loading,
      addprefrences:Prefrences.addprefrences

    })

const mapDispatchToProps = dispatch => ({
    onGetClientDetail: clientId => dispatch(getClientDetail(clientId)),
    postHomePref: (data) => dispatch(postHomePref(data)),
    onGetHomePref: (clientId) => dispatch(getHomePref(clientId)),
    updateHomePref:(data) => dispatch(updateHomePref(data)),
    createAddHomePref:(data) => dispatch(createAddHomePref(data)),
    onGetAddHomePref: clientId => dispatch(getAddHomePref(clientId)),
    onUpdateAddPref:(data) => dispatch(updateAddHomePref(data)),
    onDeleteHomePref:(data) => dispatch(deleteHomePref(data)),

});


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(homePref))